// extracted by mini-css-extract-plugin
export default {"FullWidth":"KopWbN2p","WhitespacePreWrap":"z_dDMTWP","MaxContent":"HDAVMWUp","BreakSpaces":"fALnWv6Z","QuestionShelf":"B732K1DR","Disabled":"ItaONLzi"};